<template>
    <div class="small-alert">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:class="'waves waves--left waves--dark'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:class="'waves waves--left-2 waves--light'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 635 101" v-bind:class="'waves waves--right waves--dark'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="waves" d="M609.27 5C599.1-1 572-4.13 536 10.73c-11.92 4.92-28.77 16.83-48.21 21.47s-35.08 1.8-50.22.62C387.09 28.87 364.75 55.14 320.43 60 258.21 66.87 229 32 161.1 31.58c-16.07-.1-28 3-44 2.82-31.25-.31-54.11-4.87-86.76 3.36C11.52 42.49.44 46.6 0 50.32c-3.47 31.47 340.84 64.75 527 44.49 61.6-6.7 100.93-18.64 107.1-42.21 4.43-16.78-8.43-37.86-24.83-47.6z"/></svg>
        <div class="small-alert__content">
            <template v-if="item.icon">
                <i class="small-alert__icon" :class="item.icon"></i>
            </template>
            <template v-if="item.image">
                <img svg-inline :src="item.image" alt />
            </template>
            <span class="small-alert__text">{{ item.text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "SmallAlert",
    props: ["item"],
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: transform 1s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateX(-100%);
}

.small-alert {
    background: white;
    overflow: hidden;
    padding: 20px 45px 20px 40px;
    display: inline-flex;
    border-radius: 0 5px 15px 0;
    position: relative;
    color: #26d4c2;
    font-size: 21px;
    max-width: 500px;

    &__content {
        display: flex;
        align-items: center;
    }

    &__icon {
        font-size: 24px;
        margin-right: 16px;
    }

    &__text {
        color: #1b394f;
        font-weight: bold;
        font-size: 16px;
    }
}

.waves {
    position: absolute;
    width: 500px;

    &--left {
        left: 10px;
        top: 0;
        transform: rotate(90deg) translateX(-56%);
        transform-origin: left;
    }

    &--left-2 {
        left: 0;
        top: 0;
        transform-origin: left;
        transform: rotate(90deg) translateX(-40%) translateY(-10%);
    }

    &--right {
        right: 0;
        bottom: 0;
        transform: rotate(-103deg) translateY(-17%) translateX(50%);
        transform-origin: right;
    }

    &--light {
        fill: #5bf4e4;
    }

    &--dark {
        fill: #26d4c2;
    }
}
</style>
